import { Factory } from '../../services/Factory';

namespace app.controllers.project {

  interface ProjectControllerScope extends any {
  }

  export class ProjectController {
    constructor(private scope: ProjectControllerScope, rootScope: IRootScope, stateService: app.services.state.StateService, navigationService, private organizationService: app.services.organization.OrganizationService, accountService: app.services.account.AccountService, private projectService: app.services.project.ProjectService, introService, $uibModal) {
      navigationService.setActiveTab("projects");
      rootScope.$broadcast("clearCurrentSelected");
      rootScope.$broadcast("navigation.batch.deselect");

      this.scope.Status = Status;

      scope.wasAccountRecentlyVerified = stateService.FlashWasAccountRecentlyVerified();

      this.LoadProjectsAndOrganizations().then(() => {

      scope.account = accountService;
      scope.selectedTab = {
        "favoriteProjects": true,
        "myProjects": false
      };


      scope.OpenNewProjectDialog = organization =>
        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_project.html",
          controller: "AddProjectController",
          scope: this.scope,
          resolve: {
            organization: () => organization
          }
        });


      scope.OpenCreditCardDialog = project =>
        $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_credit_card.html",
          controller: "CreditCardModalController",
          scope: this.scope,
          resolve: {
            project: () => project,
            message: () => ""
          }
        });


      scope.StartIntro = () => {
        introService.startProjectPageIntro(this.scope.projects);


        scope.$on("IntroService.currentStepChanged", (event, step) => {
          console.log("Step: " + step);

          switch (step) {
            case 3:
              scope.$apply(() => {
                scope.selectedTab.favoriteProjects = true;
                scope.selectedTab.myProjects = false;
              });
              break;
            case 4:
              scope.$apply(() => {
                scope.selectedTab.favoriteProjects = false;
                scope.selectedTab.myProjects = true;
              });
              break;
          }
        });
      }
      });
    }

    private async LoadProjectsAndOrganizations() {
      const promise1 = this.projectService.FindAll();
      const promise2 = this.organizationService.FindAll();

      const [projects, organizations] = await Promise.all([promise1, promise2]);

      this.scope.projects = projects;
      this.scope.organizations = organizations;

      this.scope.$applyAsync();
    }
  }

  frontendApp.controller("ProjectController", ["$scope", "$rootScope", "StateService", "NavigationService", "OrganizationService", "AccountService", "ProjectService", "IntroService", "$uibModal", Factory.Create(ProjectController)]);
}
